<template>
  <VRow justify="center">
    <ValidationObserver
      ref="password"
      v-slot="{ invalid }"
      name="password"
      class="w-100"
      tag=div
    >
      <VCol
        class="px-2 pb-2 d-flex align-center pt-0"
        cols="12"
      >
        <div>
          <span class="body-1">
            {{ $t('authForm.phoneNumber') }}
          </span>
        </div>
        <div class="ml-2">
          <span class="body-bold">
            {{ phone }}
          </span>
        </div>
        <div class="ml-2">
          <VBtn
            small
            class="box-shadow-elevation-4"
            data-test="edit-phone-button"
            @click="$emit('toStartStep'), isPasswordCorrect = true"
          >
            <span class="small-button">
              {{ $t('general.edit') }}
            </span>
          </VBtn>
        </div>
      </VCol>
      <VCol
        class="px-2 pb-6 d-flex pt-0"
        cols="12"
      >
        <span class="body-2">
          {{ $t('authForm.fillPassword') }}
        </span>
      </VCol>
      <VCol
        class="px-2 pb-3 pt-0"
        cols="12"
        data-test="passwordFieldContainer"
      >
        <ValidationProvider
          ref="newPassword"
          v-slot="{ errors, ariaInput }"
          name="newPassword"
          :rules="{ required: true, min: 6, max: 40, withoutSpaces: /^\S*$/ }"
          mode="aggressive"
        >
          <VTextField
            v-bind="ariaInput"
            v-model="password"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            name="input-10-2"
            data-test="passwordFieldAuth"
            :hide-details="!errors.length && isPasswordCorrect"
            :label="`${$t('authForm.password')}`"
            :error="!!errors.length || !isPasswordCorrect"
            :errorMessages="(!isPasswordCorrect) ? $t('authForm.errors.incorrectPassword') : validationErrorResolve(errors[0]) "
            class="body-1 pt-0"
            @input="isPasswordCorrect = true"
            @click:append="showPassword = !showPassword"
            @keyup.enter="onSubmit"
          />
        </ValidationProvider>
      </VCol>
      <VCol
        class="px-2 pb-3 pt-0"
        cols="12"
        col="12"
      >
        <VBtn
          class="w-100 border-radius-8"
          dark
          data-test="signInButton"
          :class="!invalid ? '' : 'disabled'"
          large
          color="brandingPrimary"
          @click="onSubmit"
        >
          <span class="button">
            {{ $t('general.next') }}
          </span>
        </VBtn>
      </VCol>
      <VCol
        class="px-2 pb-2 pt-0"
        cols="12"
        col="12"
      >
        <a
          class="secondary--text body-1 text-decoration-underline"
          data-test="forgot-password-link"
          @click="$emit('toResetPassword')"
        >
          {{ $t('authForm.forgotPassword') }}
        </a>
      </VCol>
    </ValidationObserver>
  </VRow>
</template>

<script lang="ts">
export default {
  name: 'SignInStep',
  // Kept in Options data so template ref="password" stays on $refs (v-model uses this).
  data() {
    return {
      password: '',
    };
  },
};
</script>

<script setup lang="ts">
import { nextTick, ref, watch } from 'vue';
import { useValidationError, useVm } from '../../../composables';

const props = defineProps({
  phone: {
    type: String,
    default: '',
  },
  attemptsIncorrectSingIn: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(['signIn']);

const { validationErrorResolve } = useValidationError();
const vm = useVm() as { $refs: { password: { validate: () => Promise<boolean> } }; password: string };

const showPassword = ref(false);
const isPasswordCorrect = ref(true);

watch(
  () => props.attemptsIncorrectSingIn,
  async () => {
    if (props.attemptsIncorrectSingIn) {
      isPasswordCorrect.value = false;
    }
  },
  { deep: true, immediate: true },
);

async function onSubmit() {
  vm.$refs.password.validate().then(async (success) => {
    if (!success) {
      return;
    }
    nextTick(async () => {
      const signInData = {
        customerAppType: 'WEB',
        phone: props.phone,
        password: vm.password,
      };
      emit('signIn', signInData);
    });
  });
}
</script>

<style scoped>

</style>
